import { IChallengeEnvironmentLaunchResponse } from '@cyber-range/cyber-range-api-ctf-challenge-client';
import { useApiClientStore } from './apiClientStore';
import { defineStore } from 'pinia';

export const useChallengeEnvironmentStore = defineStore('challengeEnvironmentStore', 
{
    actions:
    {
        launch(challengeEnvironmentId: string): Promise<IChallengeEnvironmentLaunchResponse> 
        {
            return useApiClientStore().backgroundChallengeEnvironmentApiClient.launch(challengeEnvironmentId);
        },
        reset(challengeEnvironmentId: string): Promise<void>
        {
            return useApiClientStore().challengeEnvironmentApiClient.reset(challengeEnvironmentId);
        },
        terminate(challengeEnvironmentId: string): Promise<void>
        {
            return useApiClientStore().challengeEnvironmentApiClient.terminate(challengeEnvironmentId);
        },
        stop(challengeEnvironmentId: string): Promise<void>
        {
            return useApiClientStore().challengeEnvironmentApiClient.stop(challengeEnvironmentId);
        },
    }
});
